module.exports = __webpack_public_path__ + "static/media/img2.ae186a01.jpeg";